/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics/FctParams';
import { FaUserCircle } from 'react-icons/fa';
import cometList from '../../../../Fct/plugins/compoundv3/helpers/cometList.json';
export var AccountData = createPlugin({
    protocol: 'COMPOUND_V3',
    type: 'GETTER',
    method: 'userBasic',
    description: 'The protocol tracks data like the principal and indexes for each account that supplies and borrows.',
    supportedContracts: cometList,
    getParams: function () { return ({
        input: {
            to: new FctAddress({}),
            methodParams: {
                account: new FctAddress({ isPreview: true, icon: FaUserCircle }),
            },
        },
        output: {
            pricinpal: new FctValue({ innerIndex: 0, isPreview: true }),
            baseTrackingIndex: new FctValue({ innerIndex: 1, isPreview: true }),
            baseTrackingAccrued: new FctValue({ innerIndex: 2, isPreview: true }),
            assetsIn: new FctValue({ innerIndex: 3, isPreview: true }),
        },
    }); },
});
